<template>
  <div
    class="flex flex-col justify-center pt-20 mb-4 bg-center bg-contain shadow-sm san-ha--banner md:mb-6 xl:mb-8 h-52 md:h-60 xl:h-72"
  >
    <div class="container px-4 mx-auto">
      <h1 class="text-4xl font-semibold leading-none md:text-6xl">
        ระบบรับสมัครออนไลน์
      </h1>
      <h2 class="text-2xl font-medium leading-none md:text-4xl text-grey-4">
        ผู้ดำรงตำแหน่งในองค์กรตามรัฐธรรมนูญและกฎหมาย
        <br />
        สำนักงานเลขาธิการวุฒิสภา
      </h2>
    </div>
  </div>
</template>
